import { render, staticRenderFns } from "./hotel-preciosM.vue?vue&type=template&id=35893cdb&"
import script from "./hotel-preciosM.vue?vue&type=script&lang=js&"
export * from "./hotel-preciosM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports